import axios from 'axios';

const rawBaseUrl = process.env.REACT_APP_API_BASE_URL || '';
const baseURL = rawBaseUrl.replace(/\/api\/?$/, '');

const api = axios.create({
  baseURL
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('taxiLeadsToken');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // If server says the token is invalid/expired and we have one stored, clear it and
    // redirect to login so the user isn't stuck with a useless "Retry" loop.
    if (error.response?.status === 401 && localStorage.getItem('taxiLeadsToken')) {
      localStorage.removeItem('taxiLeadsToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
